import React, { useState } from 'react';
import { Button, Modal } from "react-bootstrap";
import Content from "/public/images/popup-icons/Content.png";
import Pronunciation from "/public/images/popup-icons/pronoun.png";
import Fluency from "/public/images/popup-icons/checkboxGreen.png";

export default function TemplateDetectionModal({
  isOpen,
  closeModal,
  title,
  data,
  template_type,
  common_sentence,
  children,
  newResult
}) {
	const [modal, setModal] = useState(isOpen);

	const closeModalInternal = () => {
		setModal(false);
		closeModal(); 
	};
  const popupText = () => {
    let message = "";

    if (template_type === "repeat") {
      message = (
        <>
          Our AI system has detected use of template in your response. You have repeated the phrase “<span className="detected-phrase">{title}</span>” more than 3 times which is banned in PTE.
        </>
      );
    } else {
      message = (
        <>
          Our AI system has detected use of template in your response. You have used the phrase “<span className="detected-phrase">{title}</span>” which is banned in PTE.
        </>
      );
    }

    return message;
  }
  const score = data.overallScore.score;
	const outOf = data.overallScore.out_of;
  const outOfNew = newResult.overall.out_of;
  const scoreNew = newResult.overall.score;
	const percent = outOf ? (score / outOf) * 100 : 0;
  const percentNew = outOfNew ? (scoreNew / outOfNew) * 100 : 0;

	return (
    <Modal
      show={modal}
      centered
      size="lg"
      backdropClassName="shadow-backdrop"
      className="practice-shadowing-modal text-translate-modal word-definition-modal pre-line template-detector"
    >
      <Modal.Header className="d-flex">
        <Modal.Title className="text-translation popup_heading m-0">
          <i
            className="fa fa-exclamation-triangle warning-icon"
            aria-hidden="true"
          ></i>
          <h4 className="mb-2 text-light fw-bold">TEMPLATE DETECTED</h4>
        </Modal.Title>

        <Button
          variant="link"
          className="modalClose-Btn p-0"
          onClick={() => closeModalInternal()}
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            width="24"
            height="24"
          >
            <path
              d="M18 6L6 18M6 6l12 12"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </Button>
      </Modal.Header>

      <Modal.Body>
        <div className="text-translation">
          <div className="fw-bold">
            <p className="template-detected-error">{popupText()}</p>
          </div>

          <hr />

          <p className="text-dark template-constraint">{data.remarks}</p>
          {newResult && newResult.overall ? (
            <div className="d-flex row justify-content-between row align-items-center recorded-waveform-visual mt-4 text-dark">
              <div className="col-12 col-md-6 text-center text-lg-start mb-4 mb-lg-0">
                <div className="d-flex flex-column flex-sm-row align-items-center gap-3 gap-sm-4 mb-3">
                  <div className="score-circle-modern" style={{ "--progress": `${percentNew}%` }}>
                    <span>{scoreNew}/{outOfNew}</span>
                  </div>
                    <h6 className="result-score mb-0">Overall Score</h6>
                  </div>
              </div>

              {/* Score Breakdown */}
              <div className='col-12 col-md-6'>
                <div className="score-card-item d-flex justify-content-between align-items-center h-100 p-3 list-score-detail-border">
                      <div className="d-flex align-items-center gap-2">
                        <img src={Content} alt="Content" className="img-fluid" style={{ width: "28px" }} />
                        <span className="label-text">
                        Content
                        </span>
                      </div>
                      <strong className="label-score">
                        {newResult.content.score}/{newResult.content.out_of}
                      </strong>
                </div>
                <div className="score-card-item d-flex justify-content-between align-items-center h-100 p-3 list-score-detail-border">
                  <div className="d-flex align-items-center gap-2">
                    <img src={Fluency} alt="Fluency" className="img-fluid" style={{ width: "28px" }} />
                    <span className="label-text">
                    Fluency
                    </span>
                  </div>
                  <strong className="label-score">
                    {newResult.fluency.score}/{newResult.fluency.out_of}
                  </strong>
                </div>
                <div className="score-card-item d-flex justify-content-between align-items-center h-100 p-3 list-score-detail-border">
                  <div className="d-flex align-items-center gap-2">
                    <img src={Pronunciation} alt="Pronunciation" className="img-fluid" style={{ width: "28px" }}/>
                    <span className="label-text">
                    Pronunciation
                    </span>
                  </div>
                  <strong className="label-score">
                    {newResult.pronunciation.score}/{newResult.pronunciation.out_of}
                  </strong>
                </div>
              </div>
            </div>
          ) : (
            <div className="d-flex row justify-content-between row align-items-center recorded-waveform-visual mt-4 text-dark">
              <div className="col-12 col-md-6 text-center text-lg-start mb-4 mb-lg-0">
                <div className="d-flex flex-column flex-sm-row align-items-center gap-3 gap-sm-4 mb-3">
                  {/* <div className="score-circle-modern">
                    {data.overallScore.score}/{data.overallScore.out_of}
                  </div> */}
                  <div className="score-circle-modern" style={{ "--progress": `${percent}%` }}>
                    <span>{score}/{outOf}</span>
                  </div>
                    <h6 className="result-score mb-0">Overall Score</h6>
                  </div>
              </div>

              {/* Score Breakdown */}
              <div className='col-12 col-md-6'>
                <div className="score-card-item d-flex justify-content-between align-items-center h-100 p-3 list-score-detail-border">
                      <div className="d-flex align-items-center gap-2">
                        <img src={Content} alt="Content" className="img-fluid" style={{ width: "28px" }} />
                        <span className="label-text">
                        Content
                        </span>
                      </div>
                      <strong className="label-score">
                        {data.contentScore.score}/{data.contentScore.out_of}
                      </strong>
                </div>
                <div className="score-card-item d-flex justify-content-between align-items-center h-100 p-3 list-score-detail-border">
                  <div className="d-flex align-items-center gap-2">
                    <img src={Fluency} alt="Fluency" className="img-fluid" style={{ width: "28px" }} />
                    <span className="label-text">
                    Fluency
                    </span>
                  </div>
                  <strong className="label-score">
                    {data.fluencyScore.score}/{data.fluencyScore.out_of}
                  </strong>
                </div>
                <div className="score-card-item d-flex justify-content-between align-items-center h-100 p-3 list-score-detail-border">
                  <div className="d-flex align-items-center gap-2">
                    <img src={Pronunciation} alt="Pronunciation" className="img-fluid" style={{ width: "28px" }}/>
                    <span className="label-text">
                    Pronunciation
                    </span>
                  </div>
                  <strong className="label-score">
                    {data.pronunciationScore.score}/{data.pronunciationScore.out_of}
                  </strong>
                </div>
              </div>
            </div>
          )}
        </div>
      </Modal.Body>
    </Modal>
  );
}
